var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"ms"},[_vm._v(" 还没有账号？"),_c('span',{staticStyle:{"color":"#69a4fa","cursor":"pointer"},on:{"click":function($event){return _vm.to('./regUrl')}}},[_vm._v("免费注册")])]),_c('div',{staticClass:"reg-com reg-login"},[_c('login',{attrs:{"pass":false},on:{"loginFun":function($event){return _vm.loginFun(arguments)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }